module.exports = __webpack_public_path__ + "static/media/detalle-gris.543f0002.svg";